import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';

import { CompanyFeatureState } from '../states';

export const selectCompanyFeatureState: MemoizedSelector<object, CompanyFeatureState> = createFeatureSelector<CompanyFeatureState>('companyFeature');
